<template>
  <div class="form-group">
                <h5 class="card-title mt-4"><a :name="id">{{ type != "" ? type : "&lt;No Type Name&gt;" }}</a></h5>

                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text" v-bind:class="{ 'form-error': !isValid(item) }" id="basic-addon1"
                      >Pickups:</span
                    >
                  </div>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Day and frequency of pickup"
                    aria-label="pickupday 1"
                    aria-describedby="basic-addon1"
                    v-bind:value="pickup"
                    v-on:change="onPickupChange"
                  />
                </div>

                <textarea
                  class="form-control"
                  id="exampleFormControlTextarea1"
                  rows="3"
                  v-bind:value="msg"
                  v-on:change="onMessageChange"
                ></textarea>
              </div>

</template>

<script>
//
export default {
  name: "BulkTypeDetailsEditor",
  props: {
    id: String,
    msg: String,
    type: String,
    pickup: String,
    onPickupChange: Function,
    onMessageChange: Function,
    item: Object
  },
    methods: {
    isValid(item) {
      if(!item)
          return false;
      if((item.name == "" || item.name == null) && this.type == "") {
          return false;
      }
      if((item.pickup == "" || item.pickup == null) && this.pickup == "") {
          return false;
      }
      if((item.message == "" || item.message == null) && this.msg == "") {
          return false;
      }
      return true
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>